'use strict';

module.exports = {
    viewIn3D: function() {
        $('body').on('click', '.viewIn3D button.open-model', event => {
            event.preventDefault();
            var url = $(event.target).closest('button').attr('data-url');
            var $viewIn3DModal = $(event.target).closest('.viewIn3D').find('#viewIn3DModal');
            var $iFrame = $viewIn3DModal.find('.responsive-iframe');
            $iFrame.attr("src", url);
            $viewIn3DModal.modal('show');
        });

        $('body').on('product:afterAttributeSelect', function (e, response) {
            var $viewIn3DContainer = response.container.find('.viewIn3D');
            var $viewIn3DButton = $viewIn3DContainer.find('button.open-model');

            if(response.data.product.threeSixtyURL) {
                $viewIn3DContainer.removeClass('d-none');
                $viewIn3DButton.attr('data-url', response.data.product.threeSixtyURL)
            } else {
                $viewIn3DContainer.addClass('d-none');
            }
        });
    },

    updateHistoryObj: function() {
        if (localStorage.plpScrollPos) {
            var scrollObj = JSON.parse(localStorage.plpScrollPos);
            scrollObj.history = window.history.length;
            localStorage.setItem('plpScrollPos', JSON.stringify(scrollObj));
        }
    }
};
